<template>
    <v-layout wrap row pb-4
              align-center
    >
        <v-flex lg11 sm12 xs12>
            <v-layout wrap align-center>
                <v-flex v-if="status" sm6 md5
                        lg3 xl3
                >
                    <labelTopic v-if="!!status_active" :class="status_active.bg_color">{{ $t(status_active.text) }}</labelTopic>
                </v-flex>
                <!-- <v-flex v-if="user_page.status != 'status_processing'"
                        class="switcher sm6 md4 lg4 xs6 mt-2 text-lg-center"
                        :class="{'pl-0': $vuetify.breakpoint.mdAndDown, 'pl-5': $vuetify.breakpoint.lgAndUp}"
                >
                    <v-switch
                        v-model="status.active"
                        v-if="status"
                        :label="$t('Активность пользователя')"
                    />
                </v-flex> -->
                <v-flex class="lg5 sm12 xs12 mt-2" :class="{'pl-0': $vuetify.breakpoint.mdAndDown, 'pl-5': $vuetify.breakpoint.lgAndUp}">
                    <linkIcon icon="edit" @click.native="OPEN_MODAL('user_info_admin')">{{$t("Редактировать профиль пользователя")}}</linkIcon>
                </v-flex>
              <v-flex
                  v-if="available_annual_certificates && available_annual_certificates.length > 0"
                  class="mt-2" :class="{'xs12': $vuetify.breakpoint.xsOnly}" lg4 md4 mb-2>
                <v-select
                    solo
                    attach
                    :items="available_annual_certificates"
                    @input="download_annual_certificate"
                    item-value="id"
                    item-text="name"
                    append-icon=""
                    class="download_certificate"
                    :value="false"
                    :single-line="true"
                    :menu-props="{ bottom: true, offsetY: true }"
                >
                  <template #append>
                    <v-icon aria-hidden="true" translate="no">
                      expand_more
                    </v-icon>
                  </template>
                  <template slot="label">
                    <linkIcon size="40px" :icon="'cert'" class="text-lg-center">
                      {{ $t('Сертификат о достижении уровня «Эксперт»') }}
                    </linkIcon>
                  </template>
                  <template slot="selection" slot-scope="props">
                    <linkIcon size="40px" :icon="'cert'" class="text-lg-center">
                      {{ $t('Сертификат о достижении уровня «Эксперт»') }}
                    </linkIcon>
                  </template>
                </v-select>
              </v-flex>
            </v-layout>
        </v-flex>
        <v-flex v-if="user_page.status == 'status_processing'" lg5>
            <v-layout row>
                <v-flex class="xs12 text-md-left text-xl-right">
                    <buttonRed class="mt-3 mr-3">{{$t("Одобрить пользователя")}}</buttonRed>
                    <buttonBdWhite class="mt-3">{{$t("Отклонить пользователя")}}</buttonBdWhite>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex v-if="user_page.status == 'status_confirmed' || user_page.status == 'status_off'" lg5 md3
                xs6 sm12
        >
            <v-layout row align-center :class="{'justify-start': $vuetify.breakpoint.xsAndDown, 'justify-end': $vuetify.breakpoint.mdAndUp}">
                <v-flex class="mr-3 text-xs-right xs9">{{$t("Заполнение профиля")}}</v-flex>
                <v-flex xs3>
                    <v-progress-circular
                        :rotate="-90"
                        :size="64"
                        :width="6"
                        :value="75"
                        class="green-text"
                    >
                        {{ user_page.user.profile_full }}%
                    </v-progress-circular>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
import linkIcon from '@/components/ui/links/with_icon/link_sprite_icon';
import labelTopic from '@/components/ui/labels/label_topic';
import buttonRed from '@/components/ui/buttons/button_red';
import buttonBdWhite from '@/components/ui/buttons/button_bd_white';
import {mapGetters, mapMutations} from 'vuex';
import i18n from "../../../i18n";

export default {
  components: {
    linkIcon,
    labelTopic,
    buttonRed,
    buttonBdWhite,
  },
  props: {
    user: {
      type: Object,
    },
    status: {
      type: Array,
    },
    user_page: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters('profile/menu', [
      'profile_menu',
    ]),
    ...mapGetters('profile/modals', [
      'user_info_admin',
    ]),
    ...mapGetters('profile/statuses', [
      'status_active',
    ]),
    available_annual_certificates () {
      const certificates = this.user_page.available_annual_certificates || [];

      return certificates.map(({issue_year, url, id}) => {
        return {
          id: id,
          name: this.$t('Сертификат за {year} год', {
            'year': issue_year
          }),
          'url': url
        }
      });
    }
  },
  methods: {
    ...mapMutations('profile/modals', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
    ]),
    download_annual_certificate(id) {
      let win = window.open(`/api/certificate/annual/user/${id}`, '_blank');
      win.focus();
    }
  },
};
</script>

